import "./LandingPage.css";
import React, { useState } from "react";
import { Modal } from "antd";
import RunwalLogo from "../Img/landing-page/R-Logo.png";
import NriLogo from "../Img/landing-page/NRI-ELITE-LOGO.png";
import MahalaxmiLogo from "../Img/landing-page/mahalaxmi-logo.png";
import Arrow from "../Img/landing-page/explore-icon.png";
import HeadingDivider from "../Img/landing-page/divider.png";
import LeftBanner from "../Img/landing-page/left-banner.gif";
import RegisterImg from "../Img/landing-page/register-now.png";
import IconOne from "../Img/landing-page/icons/1.png";
import IconTwo from "../Img/landing-page/icons/2.png";
import IconThree from "../Img/landing-page/icons/3.png";
import IconFour from "../Img/landing-page/icons/4.png";
import { LuIndianRupee } from "react-icons/lu";
import WebsiteForm from "../Component/WebsiteForm";
import { Helmet } from "react-helmet";

export default function LandingPageSingapore() {
  const [modal1Open, setModal1Open] = useState(false);
  return (
    <>
      <Helmet>
        <title>Mumbai Property Expo 2024 in Singapore</title>
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Mumbai Property Expo 2024 in Singapore"
        />
        <meta
          property="og:description"
          content="The South Mumbai skyline is iconic and Mahalaxmi features distinctly in it. This magnificent project by Runwal is poised to be a symbolic addition to this eminent collection, positioned to cater to both discerning homebuyers and prudent investors."
        />
        <meta
          property="og:url"
          content="https://propexpo.infairs.co.in/mahalaxmi-singapore"
        />
        <meta
          property="og:image"
          content="https://propexpo.infairs.co.in/static/media/banner.988f8e827a1ed68a0267.png"
        />
        <link
          rel="canonical"
          href="https://propexpo.infairs.co.in/mahalaxmi-singapore"
        />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-WTRBETSD2R"></script>
        <script>
          {`window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-WTRBETSD2R');`}
        </script>
      </Helmet>
      <div className="landing-page-dubai">
        <section className="banner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="top-logo">
                  <img
                    src={NriLogo}
                    className="img-fluid"
                    alt="NRI Elite Logo"
                  />
                  <img
                    src={RunwalLogo}
                    className="img-fluid"
                    alt="Runwal Logo"
                  />
                </div>
              </div>
              <div className="col-12 text-center mt-4">
                <img
                  src={MahalaxmiLogo}
                  className="img-fluid mid-logo"
                  alt="Mahalaxmi Logo"
                />
                <h1>LIVE EXTRAORDINAIRE</h1>
                <img
                  src={Arrow}
                  className="img-fluid explore-icon"
                  alt="Explore"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="overview-section pt-4 pt-lg-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div className="heading">
                  {/* <span>overview</span> */}
                  <h2>A GOLDEN OPPORTUNITY TO PRE-BOOK YOUR HOME</h2>
                  <img src={HeadingDivider} className="img-fluid" alt="" />
                  <p>
                    The South Mumbai skyline is iconic and Mahalaxmi features
                    distinctly in it. This magnificent project by Runwal is
                    poised to be a symbolic addition to this eminent collection,
                    positioned to cater to both discerning homebuyers and
                    prudent investors.
                  </p>
                  <p>
                    Expect exclusive luxury, unparalleled convenience and
                    ultra-modern living in the centre of a city everybody
                    desires to call home.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="overview-section event-detail-section py-4 bg-light mb-5">
          <div className="container">
            <div className="row ">
              <div className="col-12 text-center">
                <h2>
                  You're Invited to Visit Mumbai's Finest Luxury Property Expo
                </h2>
              </div>
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="event-detail">
                  <div className="content">
                    <div className="left-section">
                      27, <br /> <span>October 2024.</span>
                    </div>
                    <div className="right-section">
                      <h4>HOLIDAY INN SINGAPORE ORCHARD CITY CENTRE</h4>
                      <p>11 Cavenagh Rd, Singapore 229616.</p>
                      <p className="date">Sun from 11:00 am to 07:00 pm</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <WebsiteForm />
              </div>
            </div>
          </div>
        </section>
        <section className="overview-section pb-5">
          <div className="container">
            <div className="row ">
              <div className="col-lg-5">
                <img
                  src={LeftBanner}
                  className="img-fluid ms-lg-3 left-banner"
                  alt="Banner"
                />
              </div>
              <div className="col-lg-7 content">
                {/* <div>
                <h2 className="mb-2">CITY SEASONS TOWERS DUBAI</h2>
                <h6 className="mb-2">
                  Sheikh Khalifa Bin Zayed Rd,
                  <br /> Next to Burjuman Mall،
                  <br /> Mankhool - Dubai - United Arab Emirates.
                </h6>
                <h3>26 & 27, October 2024.</h3>
                <h3>Sat - Sun from 11:00 am to 07:00 pm</h3>
              </div> */}
                <div>
                  <h4 className="mb-2">2, 3 & 4 BHK LUXURY RESIDENCES</h4>
                  <p className="mb-4 content-text">
                    Book your 2, 3, or 4 BHK apartment with Runwal Real Estates
                    Pvt. Ltd. and Shreepati Build Infra Investment Limited.
                    These homes offer modern amenities, spacious layouts, and
                    are located in prime areas. Whether you need a cozy 2 BHK or
                    a larger 4 BHK, find the perfect home for your family today!
                  </p>
                </div>
                <div className="head">
                  <p className="ps-lg-0">Configuration</p>
                  <p>
                    Starting at (<LuIndianRupee />)
                  </p>
                  <p>
                    Pre-book at (<LuIndianRupee />)
                  </p>
                </div>
                <div className="head-content">
                  <div>
                    <p className="pt-0">2 BHK</p>
                    <p>3 BHK</p>
                    <div>
                      <p>4 BHK*</p>
                      <span>(JODI AVAILABLE)</span>
                    </div>
                  </div>
                  <div>
                    <p className="pt-0">3.92 CR*</p>
                    <p>5.94 CR*</p>
                    <p>10.37 CR*</p>
                  </div>
                  <div>
                    <p className="pt-0">4.5 LACS*</p>
                    <p>9 LACS*</p>
                    <p>11 LACS*</p>
                  </div>
                </div>

                {/* <button type="button" onClick={() => setModal1Open(true)}>
                  Register Now
                </button> */}
              </div>
            </div>
          </div>
        </section>
        <section className="overview-section four-cards-section pb-4">
          <div className="container">
            <div className="row ">
              <div className="col-12 content">
                <div className="four-card">
                  <div>
                    <div className="icon-img">
                      <img src={IconOne} className="img-fluid" alt="" />
                    </div>
                    <p>
                      Exceptional 11 ft. Clear <br /> Height Floor To Ceiling
                    </p>
                  </div>
                  <div>
                    <div className="icon-img">
                      <img src={IconTwo} className="img-fluid" alt="" />
                    </div>
                    <p>
                      Around 1.5 Acres of <br /> Podium Amenities
                    </p>
                  </div>
                  <div>
                    <div className="icon-img">
                      <img src={IconThree} className="img-fluid" alt="" />
                    </div>
                    <p>
                      Grand Clubhouse of <br /> About 63,000 sq.ft
                    </p>
                  </div>
                  <div>
                    <div className="icon-img">
                      <img src={IconFour} className="img-fluid" alt="" />
                    </div>
                    <p>
                      One of Mumbai's <br /> Tallest Towers
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <b>
                  <a
                    href="https://runwalgroup.in/"
                    target="_blank"
                    rel="noopener noreferrer">
                    {" "}
                    www.runwalgroup.in
                  </a>{" "}
                  | Site Address: 7 Mahalaxmi, Junction of Sane Guruji Marg &
                  N.M. Joshi Marg, Mumbai 400 011.
                </b>
                <i className="d-block">
                  This project has been registered via MahaRERA Registration No.
                  PR1170002400011 available on
                  http://maharera.mahaonline.gov.in.
                </i>
                <p>
                  7 Mahalaxmi is a project being developed in phase wise manner
                  jointly by Runwal Real Estates Pvt. Ltd. and Shreepati Build
                  Infra Investment Limited. The offer is valid for a limited
                  purpose only and on select apartments and the promoter
                  reserves the right to modify or withdraw the same. This
                  material does not constitute an offer and/or contract of any
                  type between the owners and the recipient. Any
                  purchaser/allottees of this project shall be governed by the
                  terms and conditions of the booking form and agreement for
                  sale to be entered into between the parties and no details
                  mentioned in this material shall in any way govern such
                  transaction. The project may undergo variations pursuant to
                  change in plans, permissions and approvals of relevant
                  authorities as per the prevailing government norms. The
                  project is financed by IndusInd Bank Limited.
                </p>
              </div>
            </div>
          </div>
        </footer>
        <Modal
          width={1000}
          centered
          open={modal1Open}
          onOk={() => setModal1Open(false)}
          onCancel={() => setModal1Open(false)}
          footer={false}>
          <div className="row landing-page-modal">
            <div className="col-lg-6 mb-3 mb-lg-0">
              <img src={RegisterImg} className="img-fluid" alt="Banner" />
            </div>
            <div className="col-lg-6">
              <WebsiteForm />
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
